import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { LayoutApp } from "src/layout/app";
import "src/style/index.scss";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <LayoutApp />
    </BrowserRouter>
  </React.StrictMode>
);
